import {
  ODataHeader,
  ODataString,
  ODataDateTime,
  ODataInteger,
} from "pbas-vue-components";
import { translate2 } from "../trans2";

function getHeaders(calculationEntity) {
  let ArchiveHeaders = [
    new ODataHeader({
      type: new ODataString("Id"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
      isIdentifier: true,
      version: 1,
    }),
    new ODataHeader({
      type: new ODataString("BillingTerm/Translations[]/LanguageCode"),
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      type: new ODataString("BillingTerm/Translations[]/Id"),
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      title: "globals.term",
      type: new ODataString("BillingTerm/Translations[]/Name", {
        getString: (item) => translate2(item.BillingTerm, "Name"),
      }),
      sortable: true,
      visible: true,
      searchable: true,
      version: 2,
      orderByKey: "BillingTerm/StartDate",
      subHeaders: [
        new ODataHeader({
          type: new ODataInteger("BillingTerm/Number"),
          visible: false,
          allowVisibilityChange: false,
          searchable: false,
        }),
      ],
    }),
    new ODataHeader({
      title: "globals.term",
      type: new ODataString("BillingTerm/Name"),
      sortable: true,
      visible: false,
      searchable: true,
      version: 2,
      allowVisibilityChange: false,
      orderByKey: "BillingTerm/StartDate",
    }),
    new ODataHeader({
      type: new ODataString("BillingTerm/Id"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      type: new ODataString("BillingTermId"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      type: new ODataString("PlanId"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      title: "headers.archive.version",
      type: new ODataString("Version"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "globals.timestamp",
      type: new ODataDateTime("Timestamp"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.pension_regulators.user",
      type: new ODataString("CreatorEmail"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
  ];
  if (calculationEntity === "Billing") {
    ArchiveHeaders.push(new ODataHeader({
      type: new ODataString("Plan/ReportConfiguration"),
      sortable: false,
      visible: false,
      searchable: false,
      allowVisibilityChange: false
    }),)
  }
  return ArchiveHeaders;
}

export default getHeaders;
